/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { editorAdd } from '../fn/editor/editor-add';
import { EditorAdd$Params } from '../fn/editor/editor-add';
import { editorGetByMenuId$Json } from '../fn/editor/editor-get-by-menu-id-json';
import { EditorGetByMenuId$Json$Params } from '../fn/editor/editor-get-by-menu-id-json';
import { editorGetByMenuId$Plain } from '../fn/editor/editor-get-by-menu-id-plain';
import { EditorGetByMenuId$Plain$Params } from '../fn/editor/editor-get-by-menu-id-plain';
import { editorRemove } from '../fn/editor/editor-remove';
import { EditorRemove$Params } from '../fn/editor/editor-remove';
import { SingleEditorDto } from '../models/single-editor-dto';

@Injectable({ providedIn: 'root' })
export class EditorService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `editorGetByMenuId()` */
  static readonly EditorGetByMenuIdPath = '/api/Editor/{menuId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `editorGetByMenuId$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  editorGetByMenuId$Plain$Response(params: EditorGetByMenuId$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SingleEditorDto>>> {
    return editorGetByMenuId$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `editorGetByMenuId$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  editorGetByMenuId$Plain(params: EditorGetByMenuId$Plain$Params, context?: HttpContext): Observable<Array<SingleEditorDto>> {
    return this.editorGetByMenuId$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SingleEditorDto>>): Array<SingleEditorDto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `editorGetByMenuId$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  editorGetByMenuId$Json$Response(params: EditorGetByMenuId$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SingleEditorDto>>> {
    return editorGetByMenuId$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `editorGetByMenuId$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  editorGetByMenuId$Json(params: EditorGetByMenuId$Json$Params, context?: HttpContext): Observable<Array<SingleEditorDto>> {
    return this.editorGetByMenuId$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SingleEditorDto>>): Array<SingleEditorDto> => r.body)
    );
  }

  /** Path part for operation `editorAdd()` */
  static readonly EditorAddPath = '/api/Editor/add';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `editorAdd()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  editorAdd$Response(params?: EditorAdd$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return editorAdd(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `editorAdd$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  editorAdd(params?: EditorAdd$Params, context?: HttpContext): Observable<void> {
    return this.editorAdd$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `editorRemove()` */
  static readonly EditorRemovePath = '/api/Editor/remove';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `editorRemove()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  editorRemove$Response(params?: EditorRemove$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return editorRemove(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `editorRemove$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  editorRemove(params?: EditorRemove$Params, context?: HttpContext): Observable<void> {
    return this.editorRemove$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
